import {AllValidationErrorTypes} from "../../enums/ErrorType";

export interface TErrorCategories {
  [key: string]: Array<any>;
}

export default class ErrorCategories {
  static categories(): TErrorCategories {
    const categories = {};
    AllValidationErrorTypes.forEach((type)=>{
      categories[type] = [];
    })
    return categories
  }
}